var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.7231C7 18.132 6.7511 18.4997 6.37151 18.6516L4.37151 19.4518C3.71463 19.7147 3 19.2309 3 18.5234V6.67774C3 6.26881 3.24899 5.90108 3.62869 5.74924L5.62869 4.94943C6.28554 4.68675 7 5.17051 7 5.87794V17.7231ZM14.2425 5.56128C14.6877 5.67257 15 6.07256 15 6.53143V18.4699C15 19.1204 14.3886 19.5978 13.7575 19.44L9.75746 18.44C9.3123 18.3287 9 17.9287 9 17.4699V5.53143C9 4.88085 9.61139 4.4035 10.2425 4.56128L14.2425 5.56128ZM21 17.3236C21 17.7325 20.751 18.1002 20.3713 18.2521L18.3713 19.0519C17.7145 19.3145 17 18.8308 17 18.1234V6.27735C17 5.86842 17.249 5.50069 17.6287 5.34884L19.6287 4.54904C20.2855 4.28636 21 4.77012 21 5.47755V17.3236Z",
    fill: "black",
    fillOpacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.6317f1cdd02f192b8e41da521e3c34f7.svg";
export { ForwardRef as ReactComponent };